import heroWalk from "@/assets/offsite/hero-walk.jpg";
import planLondon from "@/assets/offsite/plan-london.jpg";
import planCountryside from "@/assets/offsite/plan-countryside.jpg";
import planMaker from "@/assets/offsite/plan-maker.jpg";
import detailTable from "@/assets/offsite/detail-table.jpg";
import detailFire from "@/assets/offsite/detail-fire.jpg";
import detailHands from "@/assets/offsite/detail-hands.jpg";

export const film = {
  hero: heroWalk,
  table: detailTable,
  fire: detailFire,
  hands: detailHands,
};

/** Cover image per plan id, plus the two in-page detail shots. */
export const planFilm: Record<string, { cover: string; details: string[] }> = {
  "london-reset": { cover: planLondon, details: [detailTable, detailFire] },
  "countryside-switch-off": { cover: planCountryside, details: [detailFire, detailTable] },
  "maker-day": { cover: planMaker, details: [detailHands, detailTable] },
};

export const coverFor = (id: string) => planFilm[id]?.cover ?? planLondon;
export const detailsFor = (id: string) => planFilm[id]?.details ?? [detailTable, detailFire];
